// extracted by mini-css-extract-plugin
export default {"tagContainer":"OJkEjcLus1U2sO3IzNY0","iconContainer":"Ml6hsNTG0qoLefmUA8u5","fade-in":"hsVX3aEE3Rr_2YCRgLyJ"};